import type { IServicesCollection } from 'src/packages/di';

import { AlertsGeneralPreferenceService } from './AlertsGeneralPreferenceService';
import type { IAlertsGeneralPreferenceService } from './IAlertsGeneralPreferenceService';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    alertsGeneralPreference: IAlertsGeneralPreferenceService;
  }
}

export async function addAlertsGeneralPreferenceService(di: IServicesCollection) {
  const service = new AlertsGeneralPreferenceService();
  // await service.loadPreferences();

  di.addSingleton('alertsGeneralPreference', service);
}
